import React from "react"
import styled from "styled-components"
import { Col, FormGroup, Label, Row } from "reactstrap"
import CustomSelect from "../../../../../../components/Common/CustomSelect"
import { getDefaultValueForSelect } from "../../../../../../helpers/utils"
import PropTypes from "prop-types"

const options = [
  { label: "Housing", value: "housing" },
  { label: "Employment", value: "employment" },
  { label: "Credit", value: "credit" }
]

const TtCampaignSpecialAdCategories = ({ isFormSubmit }) => {
  return (
    <TtCampaignSpecialAdCategoriesStyled>
      <FormGroup className="mb-3">
        <Label htmlFor="">Special ad categories
          <p
            className="text-muted mt-1 mb-1" style={{fontWeight: 400}}>
            {`By selecting a housing, employment, or credit campaign below, I centify not to use TikTok to discriminated based on protected characteristics in ads relating to housing, employment, or credit and to adhere to TikTok's special ad category policy`}
          </p>
        </Label>
        <Row>
          <Col md={6}>
            <CustomSelect
              name="special-ad-categories"
              options={options}
              placeholder="No categories declared"
              classNamePrefix="select2-selection"
              // errorMessage="Categories select is required"
              defaultValue={getDefaultValueForSelect(null)}
              isLoading={false}
              isMulti
              // required
              isFormSubmit={isFormSubmit}
              // onChange={(p,q) => setApp(p)}
            />
          </Col>
        </Row>
      </FormGroup>
    </TtCampaignSpecialAdCategoriesStyled>
  )
}

TtCampaignSpecialAdCategories.propTypes = {
  isFormSubmit: PropTypes.bool.isRequired
}

const TtCampaignSpecialAdCategoriesStyled = styled.div`
`

export default (TtCampaignSpecialAdCategories)
